import './index.css';
import React from 'react';
import { render } from "react-dom";

import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'
import { Provider } from 'react-redux';
import Translations from './libraries/Translations';
import Store from './redux/store';



const Theme = createTheme({
  typography: {
    fontFamily: "'inter', sans-serif",
    button: {
      textTransform: 'none',
      fontSize:  16,
      fontWeight: 400,
    }
  },
  palette: {
    primary: {
      main: 'rgb(97, 169, 255)',
      contrastText: '#ffffff',
    },
    secondary: {
      main: 'rgb(148, 164, 196)',
      contrastText: '#ffffff',
    },
    success: {
      main: "rgb(44, 197, 189)",
      contrastText: '#ffffff',
    },
    error: {
      main: "rgb(255, 34, 94)",
      contrastText: '#ffffff',
    },
    info: {
      main: "rgb(5, 135, 253)",
      contrastText: '#ffffff',
    },
    warning: {
      main: "rgb(255, 151, 119)",
      contrastText: '#ffffff',
    },
  },
});

const root = document.getElementById("root");

render(
<Provider store={Store}>
      <IntlProvider translations={Translations}>
        <ThemeProvider theme={Theme}>
          <App />
        </ThemeProvider>
      </IntlProvider>
    </Provider>
, root);
